import DisclaimerModal from './DisclaimerModal';

export default DisclaimerModal;
